export enum WarehouseSidebarStatus {
  Visible = 'visible',
  Hidden = 'hidden',
}
